import { WarningAlt } from '@carbon/icons-react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface SubmitConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  commentCount: number;
  isSubmitting?: boolean;
}

export const SubmitConfirmationModal = ({
  open,
  onClose,
  onSubmit,
  commentCount,
  isSubmitting = false,
}: SubmitConfirmationModalProps) => {
  const hasNoComments = commentCount === 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {hasNoComments && <WarningAlt size={24} />}
          Submit Code Review
        </Box>
      </DialogTitle>
      <DialogContent>
        {hasNoComments ? (
          <Alert severity='warning' sx={{ mb: 2 }}>
            You haven&apos;t added any comments yet. Are you sure you want to
            submit without providing feedback on the code?
          </Alert>
        ) : (
          <DialogContentText>
            You have added <strong>{commentCount}</strong> comment
            {commentCount !== 1 ? 's' : ''} to this code review. Once submitted,
            you won&apos;t be able to make further changes.
          </DialogContentText>
        )}
        <DialogContentText sx={{ mt: 2 }}>
          Are you sure you want to submit your code review?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button variant='outlined' onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onSubmit}
          color={hasNoComments ? 'warning' : 'primary'}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Review'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
